<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <label :for="'inputField_' + inputData.id" class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>
        <div class="form__input-container--select">
            <select class="form__input--select"
                :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                :id="'inputField_' + inputData.id"
                :name="inputData.id"
                :required="inputData.required"
                :class="inputData.error ? 'form__input--error' : ''"
                v-model="selected[0]"
                @change="updateInputOptions">
                <option value="0">Velg fra listen...</option>
                <option v-for="inputOption in inputData.inputoptions.sort((a, b) => a.order - b.order)"
                    :value="inputOption.id"
                    :key="inputOption.id">{{ inputOption.text }}</option>
            </select>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';

export default {
    props: ['inputData', 'selectedOptions'],
    emits: ['inputOptions'],
    components: {
        'required-indicator': RequiredIndicator
    },
    data() {
        return{
            selected: [0],
            options: [],
        }
    },
    methods: {
        updateInputOptions(){
            this.$emit('inputOptions', this.options, this.selected);
        },
        updateOptions(){
            this.options = [];
            this.inputData.inputoptions.forEach((inputOption) => {
                this.options.push(inputOption.id);
            });
        }
    },
    mounted(){
        this.updateOptions();
    },
    watch: {
        inputData(){
            this.updateOptions();
        },
        selectedOptions(newVal, oldVal) {
            const selectedIds = newVal.map(i => i.id);
            for (const id of selectedIds) {
                if (!id || !this.options.includes(id) || this.selected.includes(id)) {
                    continue;
                }

                this.selected = [id];
            }
        }
    }
}
</script>